import { render, staticRenderFns } from "./NinjaHeader.vue?vue&type=template&id=6edea98f&scoped=true&"
import script from "./NinjaHeader.vue?vue&type=script&lang=js&"
export * from "./NinjaHeader.vue?vue&type=script&lang=js&"
import style0 from "./NinjaHeader.vue?vue&type=style&index=0&id=6edea98f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edea98f",
  null
  
)

export default component.exports